package top.wcpe.allincore.dsl.compiler.source

/**
 * 从资源路径推导 screen id 的工具。
 *
 * 规则（与历史 CompilationPipeline 行为一致）：
 * - 反斜杠归一化为正斜杠，去掉 `.allin` 后缀
 * - 以 `ui/` 开头 → 去掉前缀
 * - 含 `/ui/` 段 → 取最后一个 `/ui/` 之后的部分
 * - 否则保留归一化后的路径
 */
object ScreenIdResolver {

    private const val UI_PREFIX = "ui/"
    private const val UI_SEGMENT = "/ui/"

    /** 推导 screen id。 */
    fun derive(path: String): String {
        val normalized = path.replace('\\', '/').removeSuffix(".allin")
        return when {
            normalized.startsWith(UI_PREFIX) -> normalized.removePrefix(UI_PREFIX)
            UI_SEGMENT in normalized -> normalized.substringAfterLast(UI_SEGMENT)
            else -> normalized
        }
    }
}
